import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Icon } from '../Icon/index.js';

/**
 * @deprecated AccordionAlpha will be used instead of Accordion moving forward, and does not have a corresponding AccordionIconAlpha. AccordionIcon will be deprecated in future major releases.
 */
const AccordionIcon = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    name,
    collapsed = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    ref: forwardedRef,
    "aria-hidden": true,
    color: "carbon600",
    name: name,
    role: "presentation",
    size: "large",
    transform: `${collapsed && name === 'ArrowCarrotRight' ? 'rotate(90deg)' : collapsed && name === 'ArrowCarrotDown' ? 'rotate(-180deg)' : 'rotate(0)'}`,
    transformOrigin: "center",
    transition: "normal",
    transitionProperty: "transform"
  }, rest));
});

export { AccordionIcon };
